module.exports = __webpack_public_path__ + "img/chuanqi_pc5.f57ba818.png";